import React from 'react';
import classnames from 'classnames';

import './Avatar.css';
import GlobalProps from '../globalProps';

interface Props extends GlobalProps {
  name?: string;
  image?: string;
  rounded?: boolean;
  size?: 'small' | 'large' | 'xl' | 'full';
}

function prefix(value?: string, count = 2): string {
  return Array.from(value || '')
    .slice(0, count)
    .join('')
    .toUpperCase();
}

export function Avatar({ name, image, rounded, size = 'small', className, style }: Props): JSX.Element {
  return (
    <div
      className={classnames(
        'avatar',
        `avatar--${size}`,
        {
          'avatar--with-image': image,
          'avatar--rounded': rounded,
        },
        className
      )}
      style={style}
    >
      {image && <img className="avatar__image" src={image} />}
      {!image && prefix(name)}
    </div>
  );
}
